import TYPES from '@/types';
import Vue from 'vue';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';

export default class LinkStrategyModerateHiringViewModel {
  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  readonly view: Vue;

  readonly i18n_namespace = 'components.strategy-moderate-wealth.link-sws-moderate.link-strategy-moderate-hiring';

  public constructor(view: Vue) {
    this.view = view;
  }

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  is_checkbox_active = false;

  is_accept_button_disabled = true;

  prevStep = () => {
    this.view.$emit('dontShowWarningChangeStrategy', false);
    this.view.$emit('prevStep');
  }

  nextStep = () => {
    this.view.$emit('nextStep');
  }

  initialize = () => {
    this.setDynamicWidth();
  }

  setDynamicWidth = () => {
    this.view.$emit('setDynamicWidth', '35');
  }

  enableAcceptButton = () => {
    this.is_accept_button_disabled = !this.is_checkbox_active;
  }
}
